import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { SuscriptionTypeFormData } from "@/formTypes/SuscriptionTypeDataType";

export type SuscriptionTypeDataType = Partial<ApiSchema["SuscriptionType"]["type"] & SuscriptionTypeFormData>;
class Api extends GenericModelApi<"SuscriptionType", SuscriptionTypeDataType> {

}
export const SuscriptionTypeApi = new Api("SuscriptionType", "nombre", "ASC");